import React from "react";
import { useParams } from "react-router-dom";
import {
  Content,
  PageTitle,
  PanelColumn,
  PageHeadingArea,
  PanelColumnSet,
} from "@backslashbuild/pp-ui";

import ContractorBankDetailsForm from "../modules/contractors/ContractorBankDetailsForm";

function EditContractorBankDetails() {
  const { id } = useParams();

  return (
    <Content scrollable>
      <PageHeadingArea>
        <PageTitle>Edit Bank Details</PageTitle>
      </PageHeadingArea>

      <PanelColumnSet>
        <PanelColumn>
          <ContractorBankDetailsForm id={id} />
        </PanelColumn>
      </PanelColumnSet>
    </Content>
  );
}

export default EditContractorBankDetails;
